/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const LedgerItemType = {
    Pass: 'Pass',
    Fail: 'Fail',
    Hint: 'Hint'
} as const;
export type LedgerItemType = typeof LedgerItemType[keyof typeof LedgerItemType];


export function LedgerItemTypeFromJSON(json: any): LedgerItemType {
    return LedgerItemTypeFromJSONTyped(json, false);
}

export function LedgerItemTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): LedgerItemType {
    return json as LedgerItemType;
}

export function LedgerItemTypeToJSON(value?: LedgerItemType | null): any {
    return value as any;
}

